"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterTimeline = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTwitterWidgets = require("react-twitter-widgets");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TwitterTimeline = props => {
  const {
    accountName
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-twitter-container"
  }, /*#__PURE__*/_react.default.createElement(_reactTwitterWidgets.Timeline, {
    dataSource: {
      sourceType: 'profile',
      screenName: accountName
    },
    options: {
      height: '600vh',
      width: '70vh',
      tweetLimit: '5'
    }
  }));
};
exports.TwitterTimeline = TwitterTimeline;
TwitterTimeline.propTypes = {
  accountName: _propTypes.default.string
};